/**
 * Centralized interviewer agent identity.
 *
 * The interviewer is a role (biographical interviewer), not a hardcoded persona.
 * Change the name here to rebrand everywhere: UI, emails, prompts, greetings.
 *
 * Out of scope: ElevenLabs agent names in agents.json are internal identifiers
 * and do not need to match this display name. ElevenLabs prompt files in
 * agent_configs/biography/prompts/*.txt must be updated manually to match.
 */
export const INTERVIEWER = {
  /** Display name shown to users in UI, emails, and conversation messages */
  name: 'Lori',

  /** Role description used in prompts and alt text */
  role: 'biographical interviewer',
} as const;
